enum PlanTaxIncludeType {
  INCLUDE = "INCLUDE",
  NOT_INCLUDE = "NOT_INCLUDE",
}

export default PlanTaxIncludeType;
